import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiSearchIcon from "@mui/icons-material/Search";
import MuiDeleteIcon from "@mui/icons-material/Delete";
import MuiTextField from "@mui/material/TextField";
import MuiCheckbox from "@mui/material/Checkbox";
import MuiFolderOpenIcon from "@mui/icons-material/FolderOpen";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelPayment from "../../model/custom/Payment";
import ControllerPaymentList from "../../controller/custom/PaymentList";
import ControllerUserList from "../../controller/UserList";
import ControllerLocalization from "../../controller/Localization";
import ViewLoader from "../Loader";
import ViewPagination from "../Pagination";
import ViewDialog from "../Dialog";

let isRendered = false;

const paymentPiListAutocompleteSlotProps = HelperSrc.createAutocompleteSlotProps("view_list_popper", [0, 0]);

const viewPagePaymentPiList: React.FC<ModelPayment.Iprops> = (props) => {
    // Variable
    const controllerPaymentList = new ControllerPaymentList(isRendered);
    const controllerUserList = new ControllerUserList(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);
    const mode = "pi";
    const dialogContent: JSX.Element[] = [];

    // Method
    controllerPaymentList.initializeHook(mode);
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (
        controllerLocalization.getStorageMain &&
        controllerPaymentList.getSelectOption &&
        controllerPaymentList.getPagination &&
        controllerPaymentList.getFilter &&
        controllerPaymentList.getDataMainList
    ) {
        return (
            <div className="view_payment_pi_list" data-at_id="view_payment_pi_list">
                <div className="button_container">
                    {(() => {
                        const html: JSX.Element[] = [];

                        if (HelperSrc.checkRole(controllerUserList.getStorageRole, ["manager", "staff"], props.userData)) {
                            html.push(
                                <MuiButton
                                    className="button_primary"
                                    data-at_id="button_create"
                                    disabled={controllerPaymentList.getApiLoadingList.selectOption}
                                    onClick={() => {
                                        controllerPaymentList.clickCreate();
                                    }}
                                >
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        if (controllerPaymentList.getApiLoadingList.selectOption) {
                                            html.push(<MuiCircularProgress className="icon_progress" />);
                                        } else {
                                            html.push(<>{controllerLocalization.getStorageMain.create}</>);
                                        }

                                        return html;
                                    })()}
                                </MuiButton>
                            );
                        }

                        return html;
                    })()}
                </div>
                <table>
                    {(() => {
                        const html: JSX.Element[] = [];

                        html.push(
                            <>
                                <colgroup>
                                    <col className="cell id" />
                                    <col className="cell name" />
                                    <col className="cell update_date" />
                                    <col className="cell client" />
                                    <col className="cell status" />
                                    <col className="cell payment_amount" />
                                    <col className="cell update_date" />
                                    <col className="cell update_by" />
                                    <col className="cell button_field" />
                                </colgroup>
                                <thead className="filter">
                                    <tr className="row filter_action">
                                        <td>
                                            <MuiButton
                                                className="button_primary container_button"
                                                data-at_id="button_apply"
                                                disabled={controllerPaymentList.getApiLoadingList.selectOption}
                                                onClick={() => {
                                                    controllerPaymentList.clickFilterApply(mode);
                                                }}
                                            >
                                                {(() => {
                                                    const html: JSX.Element[] = [];

                                                    if (controllerPaymentList.getApiLoadingList.selectOption) {
                                                        html.push(<MuiCircularProgress className="icon_progress" />);
                                                    } else {
                                                        html.push(
                                                            <span className="button_label">
                                                                {controllerLocalization.getStorageMain.apply} <MuiSearchIcon />
                                                            </span>
                                                        );
                                                    }

                                                    return html;
                                                })()}
                                            </MuiButton>
                                        </td>
                                    </tr>
                                    <tr className="row not_hover">
                                        <th className="cell field_container">{controllerLocalization.getStorageMain.id}</th>
                                        <th className="cell field_container">{controllerLocalization.getStorageMain.name}</th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={paymentPiListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerPaymentList.getSelectOption.date)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li className="date" {...props}>
                                                                {option.display_name
                                                                    ? HelperSrc.localeFormat(new Date(option.display_name))
                                                                    : controllerLocalization.getStorageMain.select}
                                                            </li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <div>
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.date
                                                                    : ""
                                                            }
                                                        />
                                                        <input
                                                            type="hidden"
                                                            className="field_value"
                                                            name="date"
                                                            defaultValue={controllerPaymentList.getElementDateValue}
                                                        />
                                                    </div>
                                                )}
                                                onChange={(_, option) => {
                                                    if (option && controllerPaymentList.setElementDateValue) {
                                                        controllerPaymentList.setElementDateValue(option.value as string);
                                                    }
                                                }}
                                            />
                                        </th>
                                        <th data-at_id="th_client" className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={paymentPiListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerPaymentList.getSelectOption.client_id)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li
                                                                {...props}
                                                                data-at_id={`select_client_${option.display_name ? option.display_name : "select"}`}
                                                            >
                                                                {option.display_name || controllerLocalization.getStorageMain.select}
                                                            </li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <div>
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.client
                                                                    : ""
                                                            }
                                                        />
                                                        <input
                                                            type="hidden"
                                                            className="field_value"
                                                            name="client_id"
                                                            data-at_id="input_client"
                                                            defaultValue={controllerPaymentList.getElementClientIdValue}
                                                        />
                                                    </div>
                                                )}
                                                onChange={(_, option) => {
                                                    if (option && controllerPaymentList.setElementClientIdValue) {
                                                        controllerPaymentList.setElementClientIdValue(option.value as string);
                                                    }
                                                }}
                                            />
                                        </th>
                                        <th className="cell field_container">{controllerLocalization.getStorageMain.status}</th>
                                        <th className="cell field_container">{controllerLocalization.getStorageMain.payment_amount}</th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={paymentPiListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerPaymentList.getSelectOption.latest_update)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li className="date" {...props}>
                                                                {option.display_name
                                                                    ? HelperSrc.localeFormat(new Date(option.display_name))
                                                                    : controllerLocalization.getStorageMain.select}
                                                            </li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        name="latest_update"
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.latest_update
                                                                : ""
                                                        }
                                                    />
                                                )}
                                            />
                                        </th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={paymentPiListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(
                                                        controllerPaymentList.getSelectOption.latest_update_by_id
                                                    )) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li {...props}>{option.display_name || controllerLocalization.getStorageMain.select}</li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <div>
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.latest_update_by
                                                                    : ""
                                                            }
                                                        />
                                                        <input
                                                            type="hidden"
                                                            className="field_value"
                                                            name="latest_update_by_id"
                                                            defaultValue={controllerPaymentList.getElementLatestUpdateByIdValue}
                                                        />
                                                    </div>
                                                )}
                                                onChange={(_, option) => {
                                                    if (option && controllerPaymentList.setElementLatestUpdateByIdValue) {
                                                        controllerPaymentList.setElementLatestUpdateByIdValue(option.value as string);
                                                    }
                                                }}
                                            />
                                        </th>
                                        <th className="cell field_container"></th>
                                        <th className="cell field_container"></th>
                                    </tr>
                                </thead>
                            </>
                        );

                        return html;
                    })()}
                    <tbody className="tbody_payment_pi_list" data-at_id="tbody_payment_pi_list">
                        {(() => {
                            const html: JSX.Element[] = [];

                            if (controllerPaymentList.getApiLoadingList.list) {
                                html.push(
                                    <tr className="row_empty">
                                        <td>
                                            <MuiCircularProgress className="icon_progress" />
                                        </td>
                                    </tr>
                                );
                            } else {
                                if (!controllerPaymentList.getPagination || Object.entries(controllerPaymentList.getPagination.data).length === 0) {
                                    html.push(
                                        <tr className="empty_state">
                                            <td colSpan={100}>
                                                <MuiFolderOpenIcon className="icon" />
                                                <p>{controllerLocalization.getStorageMain.no_result}</p>
                                            </td>
                                        </tr>
                                    );
                                } else {
                                    for (const [key, data] of Object.entries(controllerPaymentList.getDataMainList)) {
                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                        let clientDisplayName = "";

                                        for (const optionData of Object.values(controllerPaymentList.getSelectOption.client_id)) {
                                            if (optionData.value === data.client_id) {
                                                clientDisplayName = optionData.display_name;
                                            }
                                        }

                                        let statusDisplayName = "";

                                        for (const optionData of Object.values(controllerPaymentList.getSelectOption.status_id)) {
                                            if (optionData.value === data.status_id) {
                                                statusDisplayName = optionData.display_name;
                                            }
                                        }

                                        html.push(
                                            <>
                                                <tr className={`row ${alternateRow}`} data-at_id={`tr_list_data_${data.id}`}>
                                                    <td className="cell id">{data.id}</td>
                                                    <td className="cell">{data.name}</td>
                                                    <td className="cell">{data.date ? HelperSrc.localeFormat(new Date(data.date)) : ""}</td>
                                                    <td className="cell" data-at_id="td_client_name">
                                                        {clientDisplayName}
                                                    </td>
                                                    <td className="cell">{statusDisplayName}</td>
                                                    <td className="cell">{data.payment_amount}</td>
                                                    <td className="cell">
                                                        {data.latest_update ? HelperSrc.localeFormat(new Date(data.latest_update)) : ""}
                                                    </td>
                                                    <td className="cell">
                                                        {(() => {
                                                            for (const optionData of Object.values(
                                                                controllerPaymentList.getSelectOption.latest_update_by_id
                                                            )) {
                                                                const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                                if (data.latest_update_by_id === optionDataTyped.value) {
                                                                    return optionDataTyped.display_name;
                                                                }
                                                            }
                                                        })()}
                                                    </td>
                                                    <td className="cell center button">
                                                        <MuiButton
                                                            className="button_primary"
                                                            data-at_id="button_dialog_open"
                                                            disabled={controllerPaymentList.getApiLoadingList.invoiceDataList}
                                                            onClick={() => controllerPaymentList.clickDialogOpen(data.id)}
                                                        >
                                                            {(() => {
                                                                const html: JSX.Element[] = [];

                                                                if (controllerPaymentList.getApiLoadingList.invoiceDataList) {
                                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                                } else {
                                                                    html.push(<>{controllerLocalization.getStorageMain.add_invoice}</>);
                                                                }

                                                                return html;
                                                            })()}
                                                        </MuiButton>
                                                        <MuiButton
                                                            className="button_primary"
                                                            data-at_id="button_save"
                                                            disabled={controllerPaymentList.getApiLoadingList.savePi}
                                                            onClick={() => controllerPaymentList.clickSavePi(data.id)}
                                                        >
                                                            {(() => {
                                                                const html: JSX.Element[] = [];

                                                                if (controllerPaymentList.getApiLoadingList.savePi) {
                                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                                } else {
                                                                    html.push(<>{controllerLocalization.getStorageMain.save}</>);
                                                                }

                                                                return html;
                                                            })()}
                                                        </MuiButton>
                                                    </td>
                                                    <td className="cell center">
                                                        {(() => {
                                                            const html: JSX.Element[] = [];

                                                            if (
                                                                HelperSrc.checkRole(
                                                                    controllerUserList.getStorageRole,
                                                                    ["superuser", "manager"],
                                                                    props.userData
                                                                )
                                                            ) {
                                                                html.push(
                                                                    <MuiDeleteIcon
                                                                        data-at_id="icon_delete"
                                                                        className="button_icon"
                                                                        onClick={(event) => controllerPaymentList.clickRemove(event, data.id)}
                                                                    />
                                                                );
                                                            }

                                                            return html;
                                                        })()}
                                                    </td>
                                                </tr>
                                                {(() => {
                                                    const html: JSX.Element[] = [];

                                                    if (
                                                        controllerPaymentList.getDataInvoicePiList &&
                                                        controllerPaymentList.getDataInvoicePiList[data.id] &&
                                                        controllerPaymentList.getDataInvoicePiList[data.id].length > 0
                                                    ) {
                                                        html.push(
                                                            <tr className="row not_hover">
                                                                <td colSpan={100}>
                                                                    <MuiAccordion data-at_id="row_accordion">
                                                                        <MuiAccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                                            <p>{controllerLocalization.getStorageMain.invoice}</p>
                                                                        </MuiAccordionSummary>
                                                                        <MuiAccordionDetails>
                                                                            <div className="table_fake">
                                                                                <div className="row not_hover">
                                                                                    <p className="cell">{controllerLocalization.getStorageMain.id}</p>
                                                                                    <p className="cell">
                                                                                        {controllerLocalization.getStorageMain.payment_date}
                                                                                    </p>
                                                                                    <p className="cell">
                                                                                        {controllerLocalization.getStorageMain.client}
                                                                                    </p>
                                                                                    <p className="cell">
                                                                                        {controllerLocalization.getStorageMain.status}
                                                                                    </p>
                                                                                    <p className="cell">
                                                                                        {controllerLocalization.getStorageMain.payment_amount}
                                                                                    </p>
                                                                                    <p className="cell">
                                                                                        {controllerLocalization.getStorageMain.payer}{" "}
                                                                                        {controllerLocalization.getStorageMain.bank_name}
                                                                                    </p>
                                                                                    <p className="cell">
                                                                                        {controllerLocalization.getStorageMain.payee}{" "}
                                                                                        {controllerLocalization.getStorageMain.bank_name}
                                                                                    </p>
                                                                                </div>
                                                                                {(() => {
                                                                                    const html: JSX.Element[] = [];

                                                                                    for (const [keyInvoice, dataInvoice] of Object.entries(
                                                                                        controllerPaymentList.getDataInvoicePiList[data.id]
                                                                                    )) {
                                                                                        const alternateRow =
                                                                                            Number(keyInvoice) % 2 === 1 ? "even" : "";

                                                                                        let payerBankNameList: string[] = [];
                                                                                        let payeeBankNameList: string[] = [];

                                                                                        for (const invoiceItem of Object.values(dataInvoice.item)) {
                                                                                            for (const optionData of Object.values(
                                                                                                controllerPaymentList.getSelectOption.payer_id
                                                                                            )) {
                                                                                                if (
                                                                                                    optionData.value ===
                                                                                                    Number(invoiceItem["payer_id"])
                                                                                                ) {
                                                                                                    payerBankNameList.push(optionData.display_name);
                                                                                                }
                                                                                            }

                                                                                            for (const optionData of Object.values(
                                                                                                controllerPaymentList.getSelectOption.payee_id
                                                                                            )) {
                                                                                                if (
                                                                                                    optionData.value ===
                                                                                                    Number(invoiceItem["payee_id"])
                                                                                                ) {
                                                                                                    payeeBankNameList.push(optionData.display_name);
                                                                                                }
                                                                                            }
                                                                                        }

                                                                                        html.push(
                                                                                            <div className={`row ${alternateRow}`}>
                                                                                                <p className="cell">{dataInvoice.id}</p>
                                                                                                <p className="cell">{dataInvoice.payment_date}</p>
                                                                                                <p className="cell">{clientDisplayName}</p>
                                                                                                <p className="cell">{statusDisplayName}</p>
                                                                                                <p className="cell">{dataInvoice.payment_amount}</p>
                                                                                                <p className="cell">
                                                                                                    {(() => {
                                                                                                        const html: JSX.Element[] = [];

                                                                                                        for (
                                                                                                            let a = 0;
                                                                                                            a < payerBankNameList.length;
                                                                                                            a++
                                                                                                        ) {
                                                                                                            html.push(
                                                                                                                <span key={a}>
                                                                                                                    {payerBankNameList[a]}
                                                                                                                </span>
                                                                                                            );
                                                                                                            if (a < payerBankNameList.length - 1) {
                                                                                                                html.push(<br key={`br-${a}`} />);
                                                                                                            }
                                                                                                        }

                                                                                                        return html;
                                                                                                    })()}
                                                                                                </p>
                                                                                                <p className="cell">
                                                                                                    {(() => {
                                                                                                        const result: JSX.Element[] = [];
                                                                                                        for (
                                                                                                            let a = 0;
                                                                                                            a < payeeBankNameList.length;
                                                                                                            a++
                                                                                                        ) {
                                                                                                            result.push(
                                                                                                                <span key={a}>
                                                                                                                    {payeeBankNameList[a]}
                                                                                                                </span>
                                                                                                            );
                                                                                                            if (a < payeeBankNameList.length - 1) {
                                                                                                                result.push(<br key={`br-${a}`} />);
                                                                                                            }
                                                                                                        }
                                                                                                        return result;
                                                                                                    })()}
                                                                                                </p>
                                                                                            </div>
                                                                                        );
                                                                                    }

                                                                                    return html;
                                                                                })()}
                                                                            </div>
                                                                        </MuiAccordionDetails>
                                                                    </MuiAccordion>
                                                                </td>
                                                            </tr>
                                                        );
                                                    }

                                                    return html;
                                                })()}
                                            </>
                                        );
                                    }
                                }
                            }

                            return html;
                        })()}
                    </tbody>
                </table>
                <ViewPagination
                    response={controllerPaymentList.getPagination}
                    api={() => {
                        controllerPaymentList.apiDataList(mode);
                    }}
                />
                <ViewDialog
                    className="pi_remove_dialog"
                    isOpen={controllerPaymentList.getIsRemoveDialogOpen}
                    isApiLoading={controllerPaymentList.getApiLoadingList.removeData as boolean}
                    labelConfirm={controllerLocalization.getStorageMain.yes}
                    onClickConfirm={() => {
                        controllerPaymentList.clickDialogRemoveConfirm(mode);
                    }}
                    labelCancel={controllerLocalization.getStorageMain.no}
                    onClickCancel={controllerPaymentList.clickDialogRemoveCancel}
                    mode={"alert"}
                    content={controllerLocalization.getStorageMain.delete_record}
                />
                {(() => {
                    dialogContent.push(
                        <table className="table_payment_pi_invoice">
                            <colgroup>
                                <col className="cell" />
                                <col className="cell" />
                                <col className="cell" />
                                <col className="cell" />
                                <col className="cell" />
                            </colgroup>
                            <thead className="filter">
                                <tr className="row not_hover">
                                    <th className="cell"></th>
                                    <th className="cell">{controllerLocalization.getStorageMain.id}</th>
                                    <th className="cell">{controllerLocalization.getStorageMain.payment_amount}</th>
                                    <th className="cell">{controllerLocalization.getStorageMain.payment_date}</th>
                                    <th className="cell">{controllerLocalization.getStorageMain.client}</th>
                                    <th className="scroll_space"></th>
                                </tr>
                            </thead>
                            <tbody data-at_id="tbody_payment_pi_invoice_list">
                                {(() => {
                                    const html: JSX.Element[] = [];

                                    if (controllerPaymentList.getApiLoadingList.invoiceDataList) {
                                        html.push(
                                            <tr className="row_empty">
                                                <td>
                                                    <MuiCircularProgress className="icon_progress" />
                                                </td>
                                            </tr>
                                        );
                                    } else {
                                        if (
                                            !controllerPaymentList.getPagination ||
                                            Object.entries(controllerPaymentList.getPagination.data).length === 0
                                        ) {
                                            html.push(
                                                <tr className="empty_state">
                                                    <td colSpan={100}>
                                                        <MuiFolderOpenIcon className="icon" />
                                                        <p>{controllerLocalization.getStorageMain.no_result}</p>
                                                    </td>
                                                </tr>
                                            );
                                        } else {
                                            if (controllerPaymentList.getDataInvoiceList) {
                                                for (const [key, data] of Object.entries(controllerPaymentList.getDataInvoiceList)) {
                                                    const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                                    let clientDisplayName = "";

                                                    for (const optionData of Object.values(controllerPaymentList.getSelectOption.client_id)) {
                                                        if (optionData.value === data.client_id) {
                                                            clientDisplayName = optionData.display_name;
                                                        }
                                                    }

                                                    html.push(
                                                        <tr className={`row ${alternateRow}`} data-at_id={`tr_list_data_${data.id}`}>
                                                            <td className="cell">
                                                                <MuiCheckbox
                                                                    className="field_value checkbox_style"
                                                                    data-at_id="selected_invoice"
                                                                    name="selected_invoice"
                                                                    defaultChecked={false}
                                                                />
                                                            </td>
                                                            <td className="cell id">{data.id}</td>
                                                            <td className="cell">{data.payment_amount}</td>
                                                            <td className="cell">{data.payment_date}</td>
                                                            <td className="cell" data-at_id="td_client_name">
                                                                {clientDisplayName}
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            }
                                        }
                                    }

                                    return html;
                                })()}
                            </tbody>
                        </table>
                    );
                })()}
                <ViewDialog
                    className="payment_pi_dialog"
                    isOpen={controllerPaymentList.getIsDialogOpen}
                    isApiLoading={controllerPaymentList.getApiLoadingList.addInvoice as boolean}
                    labelConfirm={controllerLocalization.getStorageMain.close}
                    onClickConfirm={controllerPaymentList.clickDialogClose}
                    labelCancel={""}
                    onClickCancel={() => {}}
                    mode={""}
                    content={dialogContent[0]}
                />
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPagePaymentPiList;
